import { useRuntime } from "../config";
const { __CMS_IFRAME__, isEdit } = useRuntime();
// 检查环境
export const envCheck = async () => {
  if (__CMS_IFRAME__ || isEdit) return false;
  return true;
};
